module.exports = __webpack_public_path__ + "static/media/awe-logo.eb91876d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/images/awe-logo.png
// module id = 453
// module chunks = 6